/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"], a = ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], t = "Jahre", n = "Jahr", s = "Monat", r = "Woche", o = "Tag", d = "Heute", M = "Keine Events", g = "Ganzt\xE4gig", h = "L\xF6schen", l = "Event erstellen", i = "dddd D MMMM YYYY", y = { weekDays: e, months: a, years: "Jahre", year: "Jahr", month: "Monat", week: "Woche", day: "Tag", today: "Heute", noEvent: "Keine Events", allDay: "Ganzt\xE4gig", deleteEvent: "L\xF6schen", createEvent: "Event erstellen", dateFormat: "dddd D MMMM YYYY" };
export {
  g as allDay,
  l as createEvent,
  i as dateFormat,
  o as day,
  y as default,
  h as deleteEvent,
  s as month,
  a as months,
  M as noEvent,
  d as today,
  r as week,
  e as weekDays,
  n as year,
  t as years
};
